import { Footer } from '@/components/layouts/Footer';
import { TracingBeam } from '@/components/ui/tracing-beam';
import {
  AboutHeroSection,
  AboutHistorySection,
  AboutServicesSection,
  AboutCommitmentSection,
  AboutCTASection,
} from '@/components/sections/about';
import { useSanityContext } from '@/sanity/SanityDataProvider';

/**
 * R2 - About Us page assembling all sections
 * R4 - Fetches Sanity data via context, passes to sections with fallback
 */
export function QuienesSomosPage() {
  const { data } = useSanityContext();

  return (
    <TracingBeam>
      <AboutHeroSection data={data?.about} />
      <AboutHistorySection data={data?.about} />
      <AboutServicesSection data={data?.about} />
      <AboutCommitmentSection data={data?.about} />
      <AboutCTASection data={data?.about} />
      <Footer data={data?.footer} contactInfo={data?.contactInfo} />
    </TracingBeam>
  );
}
